module.exports = __webpack_public_path__ + "img/hr-steam-turbine-V.78f8d39d.png";